import HistoryComponent from "./HistoryComponent.svelte";

window.HistoryComponent = (options) => {
    return new HistoryComponent(options);
}